import React from 'react'

import { Helmet } from 'react-helmet'

import Header from '../../components/header'
import Footer from '../../components/footer'
import Whatsapp from '../../components/whatsapp'
import './direito-bancrio.css'

const DireitoBancrio = (props) => {
  return (
    <div className="direito-bancrio-container10">
      <Helmet>
        <title>Direito-Bancrio - Adv. Wanderson H Cavalari - Cuiabá</title>
        <meta
          name="description"
          content="Advogado em Cuiabá a mais de 10 anos, defendendo seus direitos com expertise e comprometimento."
        />
        <meta
          property="og:title"
          content="Direito-Bancrio - Adv. Wanderson H Cavalari - Cuiabá"
        />
        <meta
          property="og:description"
          content="Advogado em Cuiabá a mais de 10 anos, defendendo seus direitos com expertise e comprometimento."
        />
      </Helmet>
      <div className="direito-bancrio-container11">
        <main className="direito-bancrio-container12">
          <div className="direito-bancrio-container13">
            <Header rootClassName="headerroot-class-name12"></Header>
            <div className="direito-bancrio-container14">
              <div className="direito-bancrio-frame46">
                <span className="direito-bancrio-text10">ÁREA DE ATUAÇÃO</span>
                <span className="direito-bancrio-text11">Direito</span>
                <span className="direito-bancrio-text12">Bancário</span>
                <span className="direito-bancrio-text13">
                  A advocacia na área bancária abrange a regulamentação e
                  litígios envolvendo instituições financeiras, clientes e
                  questões de mercado. Inclui desde contratos de crédito e
                  financiamento até disputas sobre investimentos, regulamentação
                  bancária e proteção do consumidor financeiro.
                </span>
              </div>
              <div className="direito-bancrio-container15">
                <span className="direito-bancrio-text14">
                  <span>Fale Comigo</span>
                </span>
                <span className="direito-bancrio-text16 Content">
                  Quer saber mais sobre esta área de atuação? Mande-me uma
                  mensagem para introduzirmos esta questão
                </span>
                <iframe
                  src="https://whc-dun.vercel.app/email"
                  scrolling="no"
                  className="direito-bancrio-iframe"
                ></iframe>
              </div>
            </div>
          </div>
          <div className="direito-bancrio-container16">
            <div className="direito-bancrio-container17">
              <div className="direito-bancrio-frame86">
                <div className="direito-bancrio-container18">
                  <div className="direito-bancrio-container19">
                    <span className="direito-bancrio-text17">
                      Ação revisional de cartão de Crédito consignado (RMC)
                    </span>
                    <span className="direito-bancrio-text18">
                      As ações revisionais de cartão de crédito consignado (RMC)
                      visam revisar as condições contratuais e os encargos
                      financeiros aplicados a esses cartões, especialmente
                      quando há indícios de cobranças abusivas, taxas excessivas
                      ou práticas contratuais prejudiciais ao consumidor.
                    </span>
                  </div>
                  <img
                    alt="image"
                    src="/bancario%20loan%20overcharge%20medium-300h.webp"
                    loading="eager"
                    className="direito-bancrio-image1 section_image"
                  />
                </div>
                <div className="direito-bancrio-container20">
                  <div className="direito-bancrio-container21">
                    <span className="direito-bancrio-text19">
                      Superendividamento
                    </span>
                    <span className="direito-bancrio-text20">
                      <span>
                        O superendividamento ocorre quando um consumidor acumula
                        dívidas de forma excessiva, tornando-se incapaz de
                        honrar seus compromissos financeiros de forma
                        sustentável. Quando uma pessoa se encontra nessa
                        situação, ela pode buscar ajuda através de uma ação de
                        superendividamento, essa ação é regulamentada pela Lei
                        14.181/2021, que instituiu a &quot;Lei de Recuperação
                        Judicial e Falência do Consumidor Superendividado&quot;.
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <br></br>
                      <span>
                        Uma ação de superendividamento pode ser uma ferramenta
                        importante para ajudar consumidores a saírem de uma
                        situação financeira difícil e recuperarem sua
                        estabilidade financeira.
                      </span>
                      <br></br>
                    </span>
                  </div>
                  <img
                    alt="pastedImage"
                    sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                    src="/debts%20medium-1500h.webp"
                    srcSet="/debts%20medium-1500h.webp 1200w, /debts%20medium-tablet.webp 800w, /debts%20medium-mobile.webp 480w"
                    className="section_image"
                  />
                </div>
                <div className="direito-bancrio-container22">
                  <img
                    alt="image"
                    src="/pix%20scam%20warning-300h.webp"
                    loading="eager"
                    className="direito-bancrio-image2 section_image"
                  />
                  <div className="direito-bancrio-container23">
                    <span className="direito-bancrio-text25">
                      <span>Golpe do Pix</span>
                      <br></br>
                    </span>
                    <span className="direito-bancrio-text28">
                      <span>
                        O &quot;golpe do Pix&quot; refere-se a práticas
                        fraudulentas envolvendo transferências financeiras por
                        meio do sistema de pagamento instantâneo Pix. Quando uma
                        pessoa é vítima desse tipo de golpe, ela pode tomar
                        várias medidas legais para buscar uma solução.
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <br></br>
                      <span>
                        É fundamental agir rapidamente ao identificar um golpe
                        do Pix para aumentar as chances de recuperar o dinheiro
                        perdido e evitar prejuízos maiores. Além disso, é
                        importante tomar medidas para proteger informações
                        pessoais e financeiras e evitar cair em golpes
                        semelhantes no futuro.
                      </span>
                      <br></br>
                    </span>
                  </div>
                </div>
                <div className="direito-bancrio-container24">
                  <img
                    alt="pastedImage"
                    sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                    src="/cloudimg%20970x472%20medium-1500h.webp"
                    srcSet="/cloudimg%20970x472%20medium-1500h.webp 1200w, /cloudimg%20970x472%20medium-tablet.webp 800w, /cloudimg%20970x472%20medium-mobile.webp 480w"
                    className="direito-bancrio-pasted-image2 section_image"
                  />
                  <div className="direito-bancrio-container25">
                    <span className="direito-bancrio-text33">
                      <span>
                        {' '}
                        Ação de venda casada (seguro, vistoria e outros)
                      </span>
                      <br></br>
                    </span>
                    <span className="direito-bancrio-text36">
                      <span>
                        A venda casada é uma prática comercial proibida pelo
                        Código de Defesa do Consumidor (CDC). Consiste em
                        condicionar a venda de um produto ou serviço à aquisição
                        de outro produto ou serviço, sem que haja a liberdade de
                        escolha por parte do consumidor. Isso inclui a imposição
                        de seguros, vistorias ou outros serviços como condição
                        para a compra de um produto principal, como um carro ou
                        uma casa.
                      </span>
                      <br></br>
                      <span>
                        É importante ressaltar que a venda casada é uma prática
                        ilegal e que os consumidores têm o direito de recusá-la
                        e denunciá-la às autoridades competentes. Ao tomar
                        medidas contra a venda casada, os consumidores
                        contribuem para a proteção de seus próprios direitos e
                        para o combate a práticas abusivas por parte das
                        empresas.
                      </span>
                      <br></br>
                    </span>
                  </div>
                </div>
                <div className="direito-bancrio-container26">
                  <div className="direito-bancrio-container27">
                    <span className="direito-bancrio-text41">
                      Conta bancária bloqueada
                    </span>
                    <span className="direito-bancrio-text42">
                      <span>
                        Quando uma conta bancária é bloqueada, isso pode
                        acontecer por várias razões, como falta de pagamento de
                        dívidas, suspeita de atividades fraudulentas ou por
                        ordem judicial.
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <br></br>
                      <span>
                        É importante ressaltar que o bloqueio de uma conta
                        bancária pode causar sérios transtornos financeiros e
                        pessoais, por isso é fundamental agir rapidamente para
                        resolver o problema e garantir o acesso aos recursos
                        financeiros necessários.
                      </span>
                      <br></br>
                    </span>
                    <span className="direito-bancrio-text47">
                      Tarifas Bancárias
                    </span>
                    <span className="direito-bancrio-text48">
                      <span>
                        Uma ação revisional de tarifas bancárias é uma medida
                        legal que um consumidor pode tomar para contestar as
                        taxas e tarifas cobradas pela instituição financeira em
                        sua conta bancária, quando se suspeita que essas taxas
                        são abusivas, injustificadas ou estão acima do permitido
                        por lei.
                      </span>
                      <br></br>
                    </span>
                  </div>
                  <img
                    alt="image"
                    src="/banc-conta-bloqueada.jpg"
                    loading="eager"
                    className="section_image"
                  />
                </div>
                <div className="direito-bancrio-container28">
                  <img
                    alt="pastedImage"
                    sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                    src="/external/pastedimage-8mya-1500h.webp"
                    srcSet="/external//pastedimage-8mya-1500h.webp 1200w, /external/pastedimage-8mya-tablet.webp 800w, /external/pastedimage-8mya-mobile.webp 480w"
                    className="section_image"
                  />
                  <div className="direito-bancrio-container29">
                    <span className="direito-bancrio-text51">
                      <span>Juros abusivos</span>
                      <br></br>
                    </span>
                    <span className="direito-bancrio-text54">
                      <span>
                        Uma ação revisional de juros abusivos é uma medida legal
                        que um consumidor pode tomar para contestar a taxa de
                        juros aplicada em contratos de financiamento,
                        empréstimos ou outras modalidades de crédito, quando se
                        suspeita que essas taxas estão acima do permitido por
                        lei ou são consideradas abusivas.
                      </span>
                      <br></br>
                    </span>
                    <span className="direito-bancrio-text57">
                      Revisional de Juros de empréstimos
                    </span>
                    <span className="direito-bancrio-text58">
                      <span>
                        Uma ação revisional de juros de empréstimos é uma medida
                        legal que um consumidor pode tomar para contestar a taxa
                        de juros aplicada em um contrato de empréstimo, quando
                        se suspeita que essa taxa está acima do permitido por
                        lei ou é considerada abusiva.
                        <span
                          dangerouslySetInnerHTML={{
                            __html: ' ',
                          }}
                        />
                      </span>
                      <br></br>
                    </span>
                  </div>
                </div>
                <div className="direito-bancrio-container30">
                  <img
                    alt="pastedImage"
                    sizes="(min-width: 992px) 1200px, (min-width: 768px) 800px, 480px"
                    src="/cloudimgio%20image%20small-1500h.webp"
                    srcSet="/cloudimgio%20image%20small-1500h.webp 1200w, /cloudimgio%20image%20small-tablet.webp 800w, /cloudimgio%20image%20small-mobile.webp 480w"
                    className="section_image"
                  />
                  <div className="direito-bancrio-container31">
                    <span className="direito-bancrio-text61">
                      Defesa em Processo de Busca e apreensão de Veículos
                    </span>
                    <span className="direito-bancrio-text62">
                      <span>
                        Quando um consumidor enfrenta um processo de busca e
                        apreensão de veículo, é importante agir rapidamente e
                        entender seus direitos legais para buscar uma defesa
                        adequada.
                      </span>
                      <br></br>
                      <br></br>
                      <span>
                        Lembre-se de que cada caso é único e pode apresentar
                        desafios específicos. Portanto, é fundamental buscar
                        orientação para garantir que seus direitos sejam
                        protegidos adequadamente e para aumentar suas chances de
                        obter um resultado favorável no processo de busca e
                        apreensão.
                      </span>
                      <br></br>
                    </span>
                    <span className="direito-bancrio-text68">
                      Revisão de contratos de veículos
                    </span>
                    <span className="direito-bancrio-text69">
                      <span>
                        Uma ação de revisão de contratos de veículos é uma
                        medida legal que um consumidor pode tomar para contestar
                        cláusulas consideradas abusivas ou ilegais em contratos
                        de financiamento, leasing ou outras modalidades de
                        aquisição de veículos
                      </span>
                      <br></br>
                      <span>
                        Lembre-se de que cada caso é único e pode variar
                        dependendo das circunstâncias específicas envolvidas.
                      </span>
                      <br></br>
                    </span>
                  </div>
                </div>
                <div className="direito-bancrio-container32">
                  <div className="direito-bancrio-container33">
                    <span className="direito-bancrio-text74">
                      Registro indevido no Registrato
                    </span>
                    <span className="direito-bancrio-text75">
                      <span>
                        O Registrato é um serviço do Banco Central do Brasil que
                        permite aos cidadãos acessar informações sobre suas
                        relações financeiras, incluindo dívidas e limites de
                        crédito, diversas vezes as instituições bancárias mesmo
                        após uma negociação de um débito vencido mantém o nome
                        da pessoa no Registrato.
                      </span>
                      <br></br>
                    </span>
                  </div>
                  <img
                    alt="image"
                    src="/banc-registrato.jpg"
                    loading="eager"
                    className="section_image"
                  />
                </div>
              </div>
            </div>
          </div>
          <Footer rootClassName="footerroot-class-name6"></Footer>
          <Whatsapp></Whatsapp>
        </main>
      </div>
    </div>
  )
}

export default DireitoBancrio
